<script lang="ts" generics="TValues, TValue extends unknown">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { fade } from 'svelte/transition';
    import FieldErrors from '$components/Form/FieldErrors.svelte';
    import { cx } from '$lib/utils/cx.js';
    import Label from '$components/Form/Label.svelte';
    import { safe } from '$lib/utils/string';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;
    export let label: string | null = null;
    export let helpLabel: string | null = null;
    export let required: boolean = false;

    export let prefixId: string = '';
    export let id: string | null = null;

    let className: string | null = null;
    export { className as class };

    $: isAsyncValidating = form.stores().isAsyncValidating(field);
    $: effectiveId =
        prefixId === ''
            ? (id ?? form.getFieldId(field))
            : safe`${prefixId}-${id ?? form.getFieldId(field)}`;
</script>

<div class={cx(className ?? '')}>
    <slot name="label" {required} {form} {field} {label} id={effectiveId}>
        {#if label !== null}
            <Label {label} {required} {form} {field} help={helpLabel} id={effectiveId} />
        {/if}
    </slot>
    <slot {form} {field} id={effectiveId} />
    {#if $isAsyncValidating}
        <div in:fade class="text-orange-600">Vérification...</div>
    {/if}
    <FieldErrors {form} {field} />
</div>
